import React, { PureComponent, PropTypes } from 'react';
import classnames from 'classnames';
import localforage from 'localforage';
import ColumnIcon from './columnicon';
import Line from './line';
import TableRow from './tablerow';
import { makeRowHavingValues, reorderRowValuesByVisibleOrder, toBase26Alpha, transpose } from '../../services/Utils'

class Assigner extends PureComponent {
    constructor({data, ...props}) {
        super(...props);

        this.state = {
            cardsToImport: null,
            columnData: transpose(data),
            columnImportSettings: [null, null, null, null]
        };

        this.assign = this.assign.bind(this);
        this.clear = this.clear.bind(this);
        this.complete = this.complete.bind(this);
    }

    static propTypes = {
        onBack: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        onComplete: PropTypes.func.isRequired
    }

    componentDidMount() {
        const { data } = this.props;

        if (!data || !data.length) return;

        const lastColumn = data[0].length - 1;

        localforage.getItem('lastColumnImportSettings')
        .then(columnImportSettings => {
            if (!columnImportSettings || columnImportSettings.length !== 4) return;

            columnImportSettings = columnImportSettings.map(column => column > lastColumn ? null : column);

            this.updateSettings(columnImportSettings);
        });
    }

    getValidCards(columnImportSettings) {
        let { data } = this.props;
        return data.filter(row => (row[columnImportSettings[0]] || '').trim() && (row[columnImportSettings[1]]).trim());
    }
    updateSettings(columnImportSettings) {
        let complete = columnImportSettings[0] !== null && columnImportSettings[1] !== null;
        let cardsToImport = complete === false ? 0 : this.getValidCards(columnImportSettings).length;
            
        this.setState({
            cardsToImport,
            columnImportSettings
        });

        localforage.setItem('lastColumnImportSettings', columnImportSettings);
    }
    assign({source, target}) {
        let columnImportSettings = this.state.columnImportSettings.map(currentSource => currentSource === source ? null : currentSource );

        columnImportSettings = [
            ...columnImportSettings.slice(0, target),
            source,
            ...columnImportSettings.slice(target + 1, 4)
        ];

        this.updateSettings(columnImportSettings);
    }
    clear(columnIndexToClear) {
        let columnImportSettings = this.state.columnImportSettings.map((currentSource, index) => index === columnIndexToClear ? null : currentSource );

        this.updateSettings(columnImportSettings);
    }
    complete() {
        let { onComplete } = this.props;
        let { columnImportSettings } = this.state;

        let values = this.getValidCards(columnImportSettings)
        .map(row => columnImportSettings.map(index => row[index] || ''))
        .map(reorderRowValuesByVisibleOrder)
        .map(makeRowHavingValues);

        onComplete(values);
    }

    render() {
        let { data, onBack, onCancel } = this.props;
        let { cardsToImport, columnData, columnImportSettings } = this.state;

        let columns = columnData.map((values, index) => {
            let label = toBase26Alpha(index);
            let selected = columnImportSettings.some(column => column === index);
            let classes = classnames({
                'column': true,
                selected
            });
            return (<div className={classes} key={index}>
                <ColumnIcon label={label} dragPayload={index} />
                <TableRow className="values" values={values} />
            </div>);
        });

        let labels = columnImportSettings.map(column => column === null ? null : toBase26Alpha(column));

        let problemCount = Math.max(0, data.length - cardsToImport);

        return (<div className="assigner">
            <h1>Select columns</h1>
            <div className="cards">
                <div className="front card">
                    <h3>Front</h3>
                    <Line className="main" label={ labels[0] } placeholder="!" populated={ labels[0] !== null } dropPayload={0} onDroppedInto={ this.assign } onDoubleClick={ () => this.clear(0) } />
                    <Line className="note" label={ labels[2] } populated={ labels[2] !== null } dropPayload={2} onDroppedInto={ this.assign } onDoubleClick={ () => this.clear(2) } />
                </div>
                <div className="back card">
                    <h3>Back</h3>
                    <Line className="main" label={ labels[1] } populated={ labels[1] !== null } placeholder="!" dropPayload={1} onDroppedInto={ this.assign } onDoubleClick={ () => this.clear(1) } />
                    <Line className="note" label={ labels[3] } populated={ labels[3] !== null } dropPayload={3} onDroppedInto={ this.assign } onDoubleClick={ () => this.clear(3) } />
                </div>
            </div>

            <h2>Drag a column from below to build your card</h2>

            <div className="table">
                {columns}
            </div>
            { problemCount > 0 ? 
                <h4 className="warning">{ `Rows that have problems: ${ problemCount }` }</h4> :
                <h4 className="success">All rows will be imported</h4>
            }
            <div className="buttons">
                <button onClick={ onCancel }>Cancel</button>
                <button onClick={ onBack }>Back</button>
                <button disabled={ cardsToImport < 1 } onClick={ this.complete }>Done</button>
            </div>
        </div>);
    }
}


export default Assigner;


// WEBPACK FOOTER //
// ./src/components/importer/assigner.js